import MengniuAnnualAudit from './src/main';

/* istanbul ignore next */
MengniuAnnualAudit.install = function(Vue) {
  Vue.component(MengniuAnnualAudit.name, MengniuAnnualAudit);
};

export default MengniuAnnualAudit;
